import { Card, Row, Col, Statistic, Button, Spin, theme } from 'antd';
import { CalendarOutlined, CheckCircleOutlined, ClockCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface MaintenanceStatistics {
  total: number;
  completed: number;
  scheduled: number;
  inProgress?: number;
}

interface MaintenanceSummaryCardProps {
  statistics?: MaintenanceStatistics;
  loading?: boolean;
}

export function MaintenanceSummaryCard({ statistics, loading }: MaintenanceSummaryCardProps) {
  const navigate = useNavigate();
  const { token } = theme.useToken();

  const total = statistics?.total ?? 0;
  const completed = statistics?.completed ?? 0;
  const scheduled = statistics?.scheduled ?? 0;
  const inProgress = statistics?.inProgress ?? 0;

  // 完了率の計算
  const completionRate = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <Card
      title="メンテナンスサマリー"
      extra={
        <Button
          type="link"
          icon={<CalendarOutlined />}
          onClick={() => navigate('/app/maintenance')}
        >
          保全カレンダーを見る
        </Button>
      }
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Spin size="large" />
        </div>
      ) : (
        <>
          <Row gutter={16} style={{ marginBottom: 24 }}>
            <Col span={8}>
              <Statistic
                title="予定"
                value={scheduled}
                suffix="件"
                prefix={<ClockCircleOutlined />}
                valueStyle={{ color: token.colorInfo, fontSize: '24px' }}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="進行中"
                value={inProgress}
                suffix="件"
                prefix={<SyncOutlined />}
                valueStyle={{ color: token.colorWarning, fontSize: '24px' }}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="完了"
                value={completed}
                suffix="件"
                prefix={<CheckCircleOutlined />}
                valueStyle={{ color: token.colorSuccess, fontSize: '24px' }}
              />
            </Col>
          </Row>
          <div
            style={{
              padding: '16px',
              background: token.colorFillQuaternary,
              borderRadius: '8px',
              textAlign: 'center',
            }}
          >
            <Statistic
              title="完了率"
              value={completionRate}
              suffix="%"
              valueStyle={{
                color: completionRate >= 80 ? token.colorSuccess : completionRate >= 50 ? token.colorWarning : token.colorError,
                fontSize: '28px',
                fontWeight: 'bold',
              }}
            />
          </div>
        </>
      )}
    </Card>
  );
}
